import { Component, Input, OnInit } from "@angular/core";
import { StateService, UIRouterGlobals } from "@uirouter/core";
import { map } from "rxjs/operators";
import { ActivitiesV5Service } from "../models/activities-v5.service";
import { Status } from "./status-classes";

@Component({
  selector: "ab-project-alerts",
  templateUrl: "./project-alerts.component.html",
})
export class ProjectAlertsComponent implements OnInit {
  @Input() public project: any;
  @Input() public emptyProject: boolean;

  public pageSize: number;
  public page: number;
  public totalPages: number;
  public currentMetricOption: any;
  public alerts: any;
  public alertCount: any;
  public metricOptions: any;
  public search: string;

  constructor(
    private $state: StateService,
    private $uiRouterGlobals: UIRouterGlobals,
    private activitiesV5Service: ActivitiesV5Service,
  ) {}

  public ngOnInit() {
    this.pageSize = 20;
    this.page = Number(this.$uiRouterGlobals.params.page);
    this.totalPages = 0;
    this.currentMetricOption = { text: "All metrics" };

    this.fetchPage(this.page).subscribe(this.addMetricFilters.bind(this));
  }

  public trackByIndex(index: number, _item: any) {
    return index;
  }

  public activityKind(alert: any) {
    return alert.activity.split(".")[1].split("_")[0];
  }

  public hasNextPage() {
    return this.page < this.totalPages;
  }
  public hasPrevPage() {
    return this.page > 1 && this.totalPages > 1;
  }
  public loadNextPage() {
    return this.fetchPage(this.page + 1).subscribe();
  }
  public loadPrevPage() {
    return this.fetchPage(this.page - 1).subscribe();
  }

  public selectMetricOption(option: any) {
    const values = Object.keys(Status.CLASSES).map(
      (key: any) => Status.CLASSES[key],
    );
    const index = values.indexOf(option.statusClass);
    if (index !== -1) {
      option.statusClass = Object.keys(Status.CLASSES)[index];
    }

    this.currentMetricOption = option;
  }

  public fetchPage(page: number) {
    const params: any = {
      projectId: this.project.id,
      activity: [
        "route.request_spike",
        "route.request_drop",
        "route.timing_spike",
        "route.timing_drop",
        "route.ratio_spike",
        "route.ratio_drop",
      ],
      limit: this.pageSize,
      page,
    };

    this.$state.go(this.$uiRouterGlobals.current.name, { page });

    return this.activitiesV5Service.query(params).pipe(
      map((data: any) => {
        this.alerts = data.activities;
        this.page = data.page;
        this.alertCount = data.count;
        this.totalPages = Math.ceil(data.count / this.pageSize);

        return data;
      }),
    );
  }

  public trackBy(_index: number, alert: any) {
    return alert.id;
  }

  private addMetricFilters(data: any) {
    this.metricOptions = [{ text: "All metrics" }];

    const seenMetrics = [];
    for (const alert of data.activities) {
      const statusClass = Status.CLASSES[alert.params.statusClass] || "";
      const text = `${statusClass} ${alert.params.metric}`;
      if (seenMetrics.indexOf(text) === -1) {
        seenMetrics.push(text);
      }
    }

    for (const m of seenMetrics) {
      const params = m.split(" ");
      const statusClass = params[0];
      this.metricOptions.push({
        text: m.replace(/^\s/, ""),
        statusClass: statusClass.length === 0 ? undefined : statusClass,
        metric: params[1],
      });
    }
  }
}
